import styled from 'styled-components'
import { SharedWrapper } from 'components/shared/RadioButtons/styles'
import { respondAbove } from 'styles/mediaQueries'

interface WrapperProps {
    isChecked: boolean
    isFullWidth: boolean
}

export const Wrapper = styled(SharedWrapper)<WrapperProps>`
    width: 100%;
    min-height: 0;
    padding: 16px 16px 16px 4px;
    white-space: nowrap;
    background-color: ${({ theme, isChecked }) =>
        isChecked ? theme.colors.primary_100 : theme.colors.grayscale_100};
    border: 0;
    border-left: 12px solid
        ${({ theme, isChecked }) =>
            isChecked ? theme.colors.primary_500 : theme.colors.grayscale_100};

    @media ${respondAbove.xl} {
        width: ${({ isFullWidth }) => (isFullWidth ? '100%' : '25%')};
        padding: 24px 16px 24px 4px;
    }

    &::before,
    &::after {
        display: none;
    }
`
